import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTestIdAttribute } from '../../hooks/useTestIdAttribute';
import { ButtonContainer } from '../Button/ButtonContainer';
import { ButtonRotator } from '../Button/ButtonRotator';
import { Text } from '../Text/Text';
import { FlexContainer } from '../layout/FlexContainer';
export const FilterSelectButton = ({ open, filterText, selectedOptionText, customSelectedOption, width, testId, isDisabled, onClick, }) => {
    const testIdAttribute = useTestIdAttribute(testId);
    const color = 'grey';
    const variant = 'light';
    const filterTextColor = 'dark';
    const selectedOptionTextColor = 'action';
    const iconColor = 'grey';
    const handleFilterClick = () => {
        if (isDisabled)
            return;
        onClick();
    };
    const selectedOptionElement = customSelectedOption ? (customSelectedOption) : (_jsx(Text, { variant: 'b2', color: selectedOptionTextColor, children: selectedOptionText }));
    return (_jsx(ButtonContainer, { color: color, size: 'small', variant: variant, width: width, onClick: handleFilterClick, ...testIdAttribute, children: _jsxs(FlexContainer, { verticalAlign: 'center', horizontalAlign: 'spaceBetween', gap: '1/2', children: [_jsxs(FlexContainer, { direction: 'row', verticalAlign: 'center', gap: true, children: [filterText && (_jsx(Text, { variant: 'b2', color: filterTextColor, children: filterText })), selectedOptionElement] }), !isDisabled && _jsx(ButtonRotator, { open: open, iconColor: iconColor })] }) }));
};
